import React from 'react';
import CoreOfferings from './CoreOfferings';
const Perfection = () => {
    return (
//         <div className="perfection section-padding bg-light">
//             <div className="container">
//                 <div className="row justify-content-center">
//                     <div className="col-xl-8">
//                         <div className="section-title text-center">
//                             <h2>Perfect for Investors</h2>
//                             <p>We offer a variety of financial solutions to cater to the diverse needs of investors, from beginners to professionals.</p>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="row">
//                 <div className="col-xl-4">
//   <a href="/MutualFundPage" className="perfection-link">
//     <div
//       className="perfection-contentt gradient-blue"
//       style={{ textAlign: 'center' }}
//     >
//       <img
//         src="/images/mutual-fund-2.png"
//         alt="Mutual Funds"
//         style={{ width: '70px', marginBottom: '15px', display: 'inline-block' }}
//       />
//       <h4>Mutual Funds</h4>
//       <p>
//         Invest in a range of diversified mutual funds, professionally managed to
//         help you build wealth over time while managing risks effectively.
//       </p>
//     </div>
//   </a>
// </div>


//                     <div className="col-xl-4">
//                         <a href="/LoanAgainstSecuritiesPage" className="perfection-link">
//                             <div className="perfection-contentt">
//                                 <h4>Loan Against Securities</h4>
//                                 <p>Unlock liquidity by borrowing against your securities, enabling you to access funds without selling your valuable assets.</p>
//                             </div>
//                         </a>
//                     </div>
//                     <div className="col-xl-4">
//                         <a href="/BondPage" className="perfection-link">
//                             <div className="perfection-contentt">
//                                 <h4>Bonds</h4>
//                                 <p>Secure your financial future with a variety of bonds, including government and corporate bonds, offering reliable returns.</p>
//                             </div>
//                         </a>
//                     </div>
//                 </div>

//                 <div className="row mt-4">
//                     <div className="col-xl-4">
//                         <a href="/AIFPage" className="perfection-content-link">
//                             <div className="perfection-contentt">
//                                 <h4>AIF (Alternative Investment Fund)</h4>
//                                 <p>Invest in niche markets with AIFs that offer high returns, specializing in private equity, hedge funds, and real estate ventures.</p>
//                             </div>
//                         </a>
//                     </div>
//                     <div className="col-xl-4">
//                         <a href="/ResearchAnalystPage" className="perfection-content-link">
//                             <div className="perfection-contentt">
//                                 <h4>Research Analyst</h4>
//                                 <p>Access in-depth analysis and insights to make informed investment decisions, backed by thorough research and market trends.</p>
//                             </div>
//                         </a>
//                     </div>
//                     <div className="col-xl-4">
//                         <a href="/GlobalAccessPage" className="perfection-content-link">
//                             <div className="perfection-contentt">
//                                 <h4>Global Access</h4>
//                                 <p>Trade across global markets with seamless access to international investment opportunities, ensuring diverse portfolio growth.</p>
//                             </div>
//                         </a>
//                     </div>
//                 </div>
//             </div>
//         </div>
<CoreOfferings />
    );
};

export default Perfection;
